import { useEffect, useRef } from 'react';

/**
 * useIsRendered is a hook that determines whether a component was re-rendered or not.
 * @returns {boolean} true if the component is re-rendered, false if it is the initial render
 */

const useIsRendered = () => {
    const isRenderedRef = useRef(false);
    useEffect(() => {
        isRenderedRef.current = true;
    }, []);
    return {
        isRendered: isRenderedRef.current,
    };
};

export default useIsRendered;